<template>
  <div class="wrp">
    <div class="top clear">
      <h1>Doshii</h1>
      <div class="search">
        <input type="text" @input="watchkey" v-model="key" />
      </div>
    </div>
    <ul class="clear page">
      <li class="active" @click="jump('/doshii')">Account Connection</li>
      <li @click="jump('/delivery')">Delivery Partners Keywords</li>
    </ul>
    <ul class="clear tab">
      <li class="active" @click="jump('/doshii')">New Request</li>
      <li @click="jump('/doshiilink')">Linked</li>
    </ul>
    <div class="table-wrp account" style="min-width:890px">
      <el-table
          :data="tableData2"
          style="width: 100%">
        <el-table-column
          label="ID"
          prop="locationId">
        </el-table-column>
        <el-table-column
          label="Venue Name"
          prop="venueName">
        </el-table-column>
        <el-table-column
          label="VENDOR"
          prop="vendor">
        </el-table-column>
        <el-table-column
          label="ADDRESS"
          prop="address">
        </el-table-column>
        <el-table-column
          label="Phone Number"
          prop="phoneNumber">
        </el-table-column>
        <el-table-column
          label="Registration Time"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="Operation"
          width="120">
          <template slot-scope="scope">
            <div class="btns clear">
              <button class="dark" @click="info(scope.row.id)">Details</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/doshii'

export default {
  data () {
    return {
      tableData2: [],
      loading: true, // 是否正在加载
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      timeout: null,
      key: ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    jump (path) {
        this.$router.push(path)
    },
    getList () {
      const data = {
        pageNum: this.page,
        pageSize: this.pagesize,
        type: 1
      }
      if (this.key.replace(/\s+/g,'') !== '')
        data.keyword = this.key
      api.getLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    info (id) {
      this.$router.push(`/doshiidetail/${id}`)
    },
    pageChange (page) {
      this.page = page
      this.tableData2 = []
      this.loading = true
      // 加载表格
      this.getList()
    },
    lstCallback (res) {
      var that = this
      if(res.data.code == 0){
        that.loading = false
        res.data.data.list.forEach(item => {
        item.createTime = that.$box.timestampToTime(item.createTime)
        item.phoneNumber = item.phoneNumber ? that.$box.formatNumber(item.phoneNumber) : ''
        })
        this.tableData2 = res.data.data.list
        this.totalRecord = res.data.data.total
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 搜索关键词，
    keySearch () {
      this.page = 1
      this.getList()
    },
    watchkey() {
      var that = this
      if (that.timeout) {
          clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
          that.keySearch.call(that, that.key)
      }, 2000) 
    }
  },
}
</script>

<style lang="scss" scoped>
.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 39px;
    h1{
      font-size: 24px;
      font-weight: 600;
      float: left;
      margin-right: 50px;
      font-family: 'PingFangSC-Semibold';
    }
    .search{
      float: right;
      width: 300px;
      border-bottom: 1px solid #fff;
      background-size: 24px 22px;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../assets/s.png');
      margin-top: -3px;
      input{
        outline: none;
        border: none;
        line-height: 30px;
        font-size: 16px;
        font-family:'PingFangSC-Regular,PingFang SC';
        width: 100%;
        background-color: transparent;
        color: #fff;
        box-sizing: border-box;
        padding-left: 30px;
      }
    }
  }
  .page{
    margin-bottom: 64px;
    li{
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #A4A5AD;
      margin-right: 40px;
      cursor: pointer;
      position: relative;
      float: left;
    }
    .active{
      color: #ffffff;
      &:after{
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        background-color: #E83A90;
        position: absolute;
        left: 0;
        bottom: -13px;
      }
    }
  }
  .tab{
    margin-bottom: 30px;
    li{
      padding: 0 58px;
      height: 60px;
      float: left;
      background-color: transparent;
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fff;
      border: 2px solid #fff;
      text-align: center;
      line-height: 58px;
      cursor: pointer;
      box-sizing: border-box;
      margin-right: 30px;
    }
    .active{
      border: 2px solid #ea3796;
      color: #ea3796;
    }
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    .dark{
      width: 100px;
      height: 40px;
      background: #151C27;
      border: 1px solid #FFFFFF;
      outline: none;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doshii/index.vue